import { buildEndPoint } from '@mairistem/tools';

import { formatFilters, formatSort } from '@/utils';
import baseUrl from './base';

export const getRecu = (identifiant) => `${baseUrl}/recus/${identifiant}`;
export const getRecus = (
  {
    page,
    perPage,
    sorts,
    filters,
    ...rest
  }: {
    page?: number;
    perPage?: number;
    sorts?: any[];
    filters?: any[];
    [key: string]: any;
  } = {
    page: 1,
    perPage: 30,
    sorts: [],
    filters: [],
  },
) =>
  buildEndPoint(`${baseUrl}/recus`, {
    page,
    perPage: perPage || 30,
    sort: formatSort(sorts),
    ...formatFilters(filters),
    ...rest,
  });
export const postRecu = () => `${baseUrl}/recus`;
export const postRecuComptant = () => `${baseUrl}/recus/comptant`;

export const putRecus = (id) => `${baseUrl}/recus/${id}`;
export const postAnnulationRecu = (id) => `${baseUrl}/recus/${id}/annulation`;
// Rejet du prélèvement en ligne (PRI) d'un reçu : déclaré à MFO, reçu annulé, paiement rejeté.
export const postRejetPrelevementRecu = (id: number) => `${baseUrl}/recus/${id}/rejet-prelevement`;
// Date limite actuelle de paiement en ligne (date_limite_regl), lue chez MFO.
export const getDateLimiteMfoRecu = (id: number) => `${baseUrl}/recus/${id}/date-limite-mfo`;

export const getRecuReglements = (id: number) => `${baseUrl}/recus/${id}/reglements`;
export const getRecusAnterieurs = (id: number) => `${baseUrl}/recus/${id}/anterieurs`;

export const searchRecus = (
  {
    page,
    query,
    perPage,
    sorts,
    filters,
    ...rest
  }: {
    page?: number;
    query?: string;
    perPage?: number;
    sorts?: any[];
    filters?: any[];
    [key: string]: any;
  } = {
    page: 1,
    query: '',
    perPage: 30,
    sorts: [],
    filters: [],
  },
) =>
  buildEndPoint(`${baseUrl}/recus/search`, {
    page,
    perPage: perPage || 30,
    q: query,
    sort: formatSort(sorts),
    ...formatFilters(filters),
    ...rest,
  });
